import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_MEANING} from '../../metamodel/Concept';

export default class MeaningNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_MEANING;
	}
}
